export const endpoints = {
  collections: () => '/dashboard/collections',
  products: code => `/dashboard/collections/${code}/products`,
  collectionDetail: recognitionCode => `/dashboard/collections/${recognitionCode}`
};
